import { uiDateLocale } from '@/utils/uiLocale';

export type DayPart = 'morning' | 'afternoon' | 'evening';

/** Lokal tid. Morgon 05–11, eftermiddag 12–17, kväll och natt övriga timmar. */
export function dayPartFromHour(hour: number): DayPart {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

export function greetingLocale(language: string | undefined): string {
  return uiDateLocale(language);
}

/** Veckodag, dag och månad på användarens språk. Första bokstaven versal. */
export function formatGreetingDate(date: Date, language: string | undefined): string {
  const locale = greetingLocale(language);
  const formatted = new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date);
  if (!formatted) return formatted;
  return formatted.charAt(0).toLocaleUpperCase(locale) + formatted.slice(1);
}

export function dashboardGreetingKey(part: DayPart, hasName: boolean): string {
  switch (part) {
    case 'morning':
      return hasName ? 'dashboard.greetingMorning' : 'dashboard.greetingMorningPlain';
    case 'afternoon':
      return hasName ? 'dashboard.greetingAfternoon' : 'dashboard.greetingAfternoonPlain';
    case 'evening':
      return hasName ? 'dashboard.greetingEvening' : 'dashboard.greetingEveningPlain';
    default: {
      const exhaustive: never = part;
      return exhaustive;
    }
  }
}

export function greetingFirstName(firstName: string | null | undefined): string {
  return firstName?.trim() ?? '';
}
